var isValidEmail = function isValidEmail(email) {
  if (email === void 0) {
    email = '';
  }
  var regExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (email.indexOf('@-') > 0) {
    return false;
  }
  return regExp.test(email);
};
module.exports = isValidEmail;